import moment from 'moment';

export default (voucher, companyName = '---', pageSize = 'A4', pageOrientation = 'portrait') => {
    // 傳票日期：民國
    const voucherMoment = moment(voucher.dat);
    const voucherDate = `民國 ${voucherMoment.year() - 1911} 年 ${voucherMoment.month()} 月 ${voucherMoment.date()} 日`;

    // 傳票類型：開帳/結帳/調整
    let voucherType = '轉帳傳票';
    if (voucher.transactionType === 12) voucherType = '開帳傳票';
    if (voucher.transactionType === 13) voucherType = '結帳傳票';
    if (voucher.transactionType === 15) voucherType = '調整傳票';
    if (voucher.cnl) {
        voucherType = `${voucherType} (已作廢)`;
    }

    // 傳票號碼
    const voucherNumber = voucher.vono;

    // 傳票狀態
    let voucherStatus = '';
    if (voucher.status === 0) voucherStatus = '待辦';
    if (voucher.status === 1) voucherStatus = '已核准';

    // 編輯人
    const editor = voucher.upD_USR;

    // 編輯時間
    const editMoment = moment(voucher.upD_DAT);
    const editTime = `${editMoment.year() - 1911}-${editMoment.format('MM-DD')}`;

    // 准許人
    const approver = voucher.statuS_DAT;

    // 准許時間
    const approveMoment = moment(voucher.statuS_DAT);
    const approveTime = `${approveMoment.year() - 1911}-${approveMoment.format('MM-DD')}`;

    // 來源系統單號
    const systemNo = voucher.unT_NBR;

    // 傳票項目 & 合計
    const items = [];
    let crdTotal = 0;
    let debTotal = 0;
    voucher.accountItems.forEach((item) => {
        items.push({
            accname: item.accno ? `${item.accno} - ${item.accnonam}` : '---',
            content: item.content,
            crdAmt: item.crD_NTD === 0 ? '' : item.crD_NTD.toLocaleString('en'),
            debAmt: item.deB_NTD === 0 ? '' : item.deB_NTD.toLocaleString('en'),
        });
        crdTotal += item.crD_NTD;
        debTotal += item.deB_NTD;
    });

    crdTotal = crdTotal.toLocaleString('en');
    debTotal = debTotal.toLocaleString('en');

    return {
        pageSize, // 頁面尺寸
        pageOrientation, // 紙張方向
        companyName, // 公司名稱
        voucherDate, // 傳票日期：民國
        voucherType, // 傳票類型
        voucherNumber, // 傳票號碼
        voucherStatus, // 傳票狀態
        editor, // 編輯人
        editTime, // 編輯時間：113-09-10
        approver, // 准許人
        approveTime, // 准許時間：113-09-10
        systemNo, // 來源系統單號
        items, // 傳票項目
        crdTotal, // 借方合計
        debTotal, // 貸方合計
    };
};
